import { atom } from "recoil";

export const SelectedCategoriesAtom = atom<string[]>({
  key: "SelectedCategoriesAtom",
  default: [],
});

export const SelectedAllowedCategoriesAtom = atom<string[]>({
  key: "SelectedAllowedCategoriesAtom",
  default: [],
});

export const NumberOfTagsInCategoryAtom = atom<{ categoryId: string }>({
  key: "NumberOfTagsInCategoryAtom",
  default: {
    categoryId: "",
  },
});
